import React, { useState, useEffect } from "react";
import Header from "../components/Header";
import MenuHamburger from "../components/MenuHamburger"
import Footer from "../components/Footer";
import { Link } from "react-scroll";
import { Helmet } from 'react-helmet'

export const Bio = () => {

  const [loaded, setLoaded] = useState(false);
  const [language, setLanguage] = useState("en");
  const [showMenuHamburger, setShowMenuHamburger] = useState(true);
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [showMobile, setShowMobile] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth > 1024) {
        setShowMobile(false);
      } else {
        setShowMobile(true);
      }
    };

    handleResize();

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth > 1023) {
        setShowMenuHamburger(false);
      } else {
        setShowMenuHamburger(true);
      }
    };

    handleResize();

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  useEffect(() => {
    setTimeout(() => {
      setLoaded(true);
    }, 1000);
  }, []);
  
  const imageStyle = {
    opacity: loaded ? 1 : 0,
    transform: loaded ? 'scale(1)' : 'scale(1.3)',
  };

  return (
    <>
    <Helmet>
      <title>Tatu Kauppinen | Biography</title>
      <meta name="description" content="Biography of Tatu Kauppinen" />
    </Helmet>
    <div className="bio-container">
      {showMenuHamburger && <MenuHamburger isMenuOpen={isMenuOpen} isBioPage={true} language={language} />}
      {!showMenuHamburger && <Header isBioPage={true} language={language}/>}
      <div className="main-bio">
        <div className="image-container">
        {!showMobile ? (
            <img 
              style={imageStyle}
              className="bio-image"
              src="https://demetrios-antoniades-nextjs-images-api.s3.eu-north-1.amazonaws.com/_AMA5086.jpg"
              onLoad={() => setLoaded(true)}
              />
              ) : (
            <img 
            className="bio-image-phone" 
            src="../photos/_AMA5174.jpg"
            />
      )}
        </div>
        {/* <div className="bio-quote-wrapper">
          <blockquote className="home-quote bio">“Lorem ipsum dolor sit amet, consectetur adipiscing elit.”</blockquote>
          <blockquote className="quoter bio"> Boethius </blockquote>
        </div> */}
        <Link id="scrollTarget" to="scrollTarget" smooth={true} duration={1000} className="down-arrow-link">
        <div className="down-arrow-bio">
          <svg className="down-arrow" xmlns="http://www.w3.org/2000/svg" fillRule="evenodd" clipRule="evenodd"><path d="M24 12c0-6.623-5.377-12-12-12s-12 5.377-12 12 5.377 12 12 12 12-5.377 12-12zm-1 0c0-6.071-4.929-11-11-11s-11 4.929-11 11 4.929 11 11 11 11-4.929 11-11zm-11.5 4.828l-3.763-4.608-.737.679 5 6.101 5-6.112-.753-.666-3.747 4.604v-11.826h-1v11.828z"/></svg>
        </div>
        </Link>
        <div className="main-bio-container">
          <h1 className="bio-heading">Biography</h1>
          <div className="bio-wrapper">
            <p className="bio-text">
              Tatu Kauppinen, born in 2000, is among the most distinguished Finnish cellists of his generation. 
              He currently lives in Berlin, where he has been based since 2022. That same year, he won First 
              Prize, the Audience Prize, and the Special Prize for the Best Interpretation of the Commissioned 
              Work at the Turku Cello Competition in Finland. This success marked the beginning of his solo 
              career, and he has since appeared as a soloist with various Finnish orchestras.
            </p>  
            <p className="bio-text">
              Kauppinen made his international solo debut in November 2022 with the Norddeutsche 
              Philharmonie Rostock. Two years later, he made his debut at the Berliner Philharmonie, 
              performing the Cello Concerto by Friedrich Gulda with the orchestra of the Karajan Academy of 
              the Berliner Philharmoniker. He has also appeared as a soloist with the Ostrobothnian Chamber 
              Orchestra, the Joensuu City Orchestra, the Lappeenranta City Orchestra, and others.
            </p>  
            <p className="bio-text">
              A passionate chamber musician from an early age, Kauppinen has performed at numerous 
              European music festivals, including Kuhmo Chamber Music, Festival de Pâques Aix-en-Provence, 
              Kammeroper Schloss Rheinsberg, Purbeck International Chamber Music Festival, and Krzyzowa 
              Music. Since 2022, he has performed regularly with Danish pianist David Munk-Nielsen, with 
              whom he has performed throughout Finland, Denmark, and Germany. In the summer of 2025, he 
              traveled to China  on a concert tour with cellist Senja Rummukainen. His artistic collaborations 
              include performances with Johannes Meissl, Sibylle Mahni, Gilbert Kalish, Nils Mönkemeyer, and 
              Paavali Jumppanen.
            </p> 
            <p className="bio-text">
              Kauppinen began studying the cello at the age of seven at the Central Helsinki Music Institute. In 
              2014, he continued his education in the Junior Department of the Sibelius Academy, where he 
              later completed his Bachelor’s degree in 2022 under Marko Ylönen. He is currently pursuing 
              further studies at the Hochschule für Musik und Theater Rostock with Prof. Natalie Clein.
              From 2023 to 2025, he was a scholarship holder of the Karajan Academy of the Berliner 
              Philharmoniker, where he studied under Martin Löhr. Alongside the Berliner Philharmoniker, his 
              other orchestra work includes substitute appearances with the Konzerthausorchester Berlin, the 
              Helsinki Philharmonic Orchestra, and the Finnish Radio Symphony Orchestra, occasionally also 
              serving as principal cellist.
            </p>
            <p className="bio-text">
              Tatu Kauppinen performs on a cello made by Pierre & Hippolyte Silvestre (1838), generously 
              loaned by a private patron. His studies and artistic career have been supported by the Finnish 
              Cultural Foundation, Pro Musica Foundation of Finland, Wegelius Foundation, and the Deutsche 
              Orchesterstiftung.
            </p>
            <a  href="https://www.dropbox.com/scl/fo/phqspwxcxa35ox5amcd9q/AJcNQr9SWhK8np9yPa-AdVs?rlkey=mdye1hexkp2i1upfimw59xe89&st=nuo8fil3&dl=1" className="contact-links-container fit-content bio-download" target="_blank">
              <span className='download-presskit navigation-icons hover-links links-contact' ><svg width="1.7em" viewBox="0 0 24 22" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M9 17L12 20M12 20L15 17M12 20V12M4 15.6458C3.70865 15.3154 3.47348 14.9387 3.30448 14.5307C3.10346 14.0454 3 13.5253 3 13C3 12.4747 3.10346 11.9546 3.30448 11.4693C3.5055 10.984 3.80014 10.543 4.17157 10.1716C4.54301 9.80014 4.98396 9.5055 5.46927 9.30448C5.95457 9.10346 6.47471 9 7 9C7 8.34339 7.12933 7.69321 7.3806 7.08658C7.63188 6.47996 8.00017 5.92876 8.46447 5.46447C8.92876 5.00017 9.47996 4.63188 10.0866 4.3806C10.6932 4.12933 11.3434 4 12 4C12.6566 4 13.3068 4.12933 13.9134 4.3806C14.52 4.63188 15.0712 5.00017 15.5355 5.46447C15.9998 5.92876 16.3681 6.47996 16.6194 7.08658C16.8707 7.69321 17 8.34339 17 9C17.5253 9 18.0454 9.10346 18.5307 9.30448C19.016 9.5055 19.457 9.80014 19.8284 10.1716C20.1999 10.543 20.4945 10.984 20.6955 11.4693C20.8965 11.9546 21 12.4747 21 13C21 13.5253 20.8965 14.0454 20.6955 14.5307C20.5265 14.9387 20.2913 15.3154 20 15.6458" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"></path></svg></span>
              <span className='hover-links links-contact margin download-presskit'>Download Biography</span>
            </a>  
          </div>
        </div>
      </div>
      <Footer/>
    </div>
    </>
  );
};

export default Bio;
